import React, { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import SaveIcon from "@mui/icons-material/Save";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Stack } from "@mui/material";
import SignatureCanvas from "react-signature-canvas";
import ClearIcon from "@mui/icons-material/Clear";
import { getBase64FromUrl } from "../helpers/getBase64FromUrl";

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default function SignatureDialog(props) {
  const sigCanvas = useRef(null);

  const [isReady, setIsReady] = React.useState(false);

  const onClearSignature = (sigRef) => {
    if (sigRef && sigRef.current) {
      sigRef.current.clear();
      props.onChange(props.id, sigRef);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await delay(100);
      if (sigCanvas.current && props.value.length > 0) {
        var base64 = props.value;

        if (
          props.value.startsWith("http://") ||
          props.value.startsWith("https://")
        ) {
          base64 = await getBase64FromUrl(props.value);
        }
        sigCanvas.current.fromDataURL(base64);
      }
    };
 
    if (isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  // useEffect(() => {
  //   // This code runs after the component mounts,
  //   // ensuring the canvas element and its API are initialized and available.
  //   if (sigCanvas.current) {
  //     console.log("Signature canvas is initialized and ready!");

  //     // You can now safely call methods on the canvas instance
  //     sigCanvas.current.fromDataURL(props.value);
  //     // const canvas = sigCanvas.current.getCanvas(); // Get the underlying canvas element
  //     // ... further canvas manipulations
  //   }
  // }, []); // The empty dependency array ensures this runs once after the initial render

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xs"}
      open={props.isOpen}
      onClose={props.onClose}
      scroll={"paper"}
    >
      <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
        {props.importTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{props.importSubtitle}</DialogContentText>

        <Box
          noValidate
          component="form"
          sx={{
            // display: "flex",
            bgcolor: "primary.main",

            flexDirection: "column",
            m: "auto",
            width: "100%",
            flexGrow: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            // style={{ display: "inline", background: "Red", marginTop: 20 }}
          >
            <SignatureCanvas
              style={{ display: "inline", background: "Red", marginTop: 20 }}
              backgroundColor="#f0f0f0"
              canvasProps={{
                width: 263,
                height: 120,
              }}
              // onBegin={() => onSigStart(idx)}
              ref={sigCanvas}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack>
          {/* <Typography color="error">{props.formErrorMessage}</Typography> */}
          <Stack direction={"row"} spacing={1}>
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={props.onClose}
            >
              Cancel
            </Button>
            <Button
              startIcon={<ClearIcon />}
              variant="outlined"
              onClick={() => onClearSignature(sigCanvas)}
            >
              Clear
            </Button>
            <Button
              // disabled={
              //   props.sigRef.current ? props.sigRef.current.isEmpty() : true
              // }
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => {
                props.onChange(props.id, sigCanvas);
                props.onClose();
              }}
            >
              Save
            </Button>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
